import { handleApiResponse } from '@src/api/apiClient/axiosClient.ts';
import { companyMenuApiClient } from '@src/api/company/menu/companyMenuApiClient.ts';
import { CompanyAuthContext } from '@src/context/auth/CompanyAuthContext';
import MobileHeader from '@src/ui/templates/Company/MobileHeader/MobileHeader';
import CompanyMenubar from '@src/ui/templates/Company/Navbar/CompanyMenubar';
import { NavItem } from '@src/ui/templates/Company/NavMenu/types.ts';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

type Props = {
  children: React.ReactNode;
  showLogo?: boolean;
  showCategoryNav?: boolean;
};

function CompanyNoMenusLayout({ children, showLogo = false }: Props) {
  const location = useLocation();
  const [navItems, setNavItems] = useState<NavItem[]>([]);

  const authContext = useContext(CompanyAuthContext);
  const { profile } = authContext ?? {};

  const updateCurrentNavItems = () => {
    const currentPath = location.pathname;

    setNavItems((prevNavItems) =>
      prevNavItems.map((item) => ({
        ...item,
        current: item.link ? currentPath.startsWith(item.link) : false,
      })),
    );
  };

  const fetchCompanyMenu = async () => {
    const res = await companyMenuApiClient.index();
    handleApiResponse(
      res,
      (data) => {
        const navItems = data.map((menu) => {
          return {
            ...menu,
            current: menu.link ? location.pathname.startsWith(menu.link) : false,
          };
        });
        setNavItems(navItems);
      },
      (error) => {
        console.error('メニューの取得に失敗しました:', error);
      },
    );
  };

  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { profile });
    }
    return child;
  });

  const hasInitialFetchCompanyMenuRef = useRef(false);
  useEffect(() => {
    if (profile && !hasInitialFetchCompanyMenuRef.current) {
      fetchCompanyMenu().then(() => {
        hasInitialFetchCompanyMenuRef.current = true;
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile]);

  useEffect(() => {
    updateCurrentNavItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <div className='min-h-screen'>
      <div className='flex flex-col'>
        <div>
          <div className='lg:block'>
            <MobileHeader navItems={navItems} />
          </div>
          <CompanyMenubar
            navItems={navItems}
            needLogo={showLogo}
          />
        </div>
        <div className='grow'>{childrenWithProps}</div>
      </div>
    </div>
  );
}

export default CompanyNoMenusLayout;
